import { useCallback } from "react";
import { APP_LIVE, storeUrlFor } from "@/config/site";
import { getPlatform } from "@/lib/device";
import { scrollToId } from "@/lib/scroll";
import { useWaitlist } from "@/context/WaitlistContext";

// Every download CTA funnels here: store on mobile, badges on desktop, waitlist pre-launch.
export const useDownload = () => {
  const { openWaitlist } = useWaitlist();
  return useCallback(
    (opts = {}) => {
      if (!APP_LIVE) return openWaitlist(opts);
      const url = storeUrlFor(getPlatform());
      if (url) window.location.href = url;
      else scrollToId("download");
    },
    [openWaitlist]
  );
};
